export * from './hospital-group-contract-lists.component';
export * from './hospital-group-contract-lists.module';
